import { Box, Button } from '@mui/material'
import { useAppState } from 'appContext'
import ComputerConnectBtn from 'components/DynamicComponents/ComputerConnectButton'
import { PasswordModal } from 'components/PasswordModal'
import { Icon } from 'packages/eid-icons'
import MasterLockOverlay from 'packages/eid-ui/MasterLockOverlay'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface ComputerCardViewProps {
    item: any
    btnLabel: string
}

export const ComputerCardView: FC<ComputerCardViewProps> = (props) => {
    const { item, btnLabel } = props
    const { t } = useTranslation()
    const [{ masterPassword }]: any = useAppState()
    const [open, setOpen] = useState<string>('')

    const handleMasterUnlock = () => {
        setOpen('enterPassword')
    }

    return (
        <Box
            sx={{
                padding: '0 10px',
            }}
        >
            {!masterPassword && (
                <PasswordModal
                    showDefaultContent={false}
                    open={open}
                    setOpen={setOpen}
                />
            )}
            <Box
                sx={{
                    padding: '20px 16px 9px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.05)',
                    backgroundColor: 'common.white',
                    marginBottom: '20px',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '20px',
                    }}
                >
                    <Box
                        sx={{
                            width: '24px',
                            height: '24px',
                        }}
                    >
                        {/* TODO: Make it dynamic as per API response */}
                        <Icon name="WindowBlue" />
                    </Box>
                    <Box
                        sx={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: 'common.black',
                            marginLeft: '16px',
                        }}
                    >
                        Friendly Name
                    </Box>
                </Box>
                <Box>
                    <Box
                        sx={{
                            fontSize: '12px',
                            color: '#9b9b9b',
                            fontWeight: 400,
                            marginBottom: '10px',
                        }}
                    >
                        DNS Name
                    </Box>
                    <Box
                        sx={{
                            fontSize: '13px',
                            color: 'common.black',
                            fontWeight: 400,
                            marginBottom: '16px',
                        }}
                    >
                        DNS Name
                    </Box>
                    <Box
                        sx={{
                            maxWidth: '200px',
                        }}
                    >
                        <MasterLockOverlay
                            btnLabel={t('Common_Unlock')}
                            showMasterLock={!masterPassword}
                            handleMasterUnlock={handleMasterUnlock}
                        >
                            <Box
                                sx={{
                                    fontSize: '12px',
                                    color: '#9b9b9b',
                                    fontWeight: 400,
                                    marginBottom: '10px',
                                }}
                            >
                                Infrastructure
                            </Box>
                            <Box
                                sx={{
                                    fontSize: '13px',
                                    color: 'common.black',
                                    fontWeight: 400,
                                    marginBottom: '16px',
                                }}
                            >
                                <Box
                                    sx={{
                                        '& > div div': {
                                            maxWidth: '100px',
                                        },
                                        '& span svg:nth-last-child(1)': {
                                            marginTop: '10px',
                                        },
                                        '& button': {
                                            padding: 0,
                                            '& div': {
                                                maxWidth: 'auto !important',
                                            },
                                        },
                                    }}
                                >
                                    <ComputerConnectBtn
                                        parentStyle={{}}
                                        showPrefixIcon={false}
                                        data={item}
                                        drawerView={false}
                                        showCalenderIcon={true}
                                    />
                                </Box>
                            </Box>
                        </MasterLockOverlay>
                    </Box>
                    <Box
                        sx={{
                            fontSize: '12px',
                            color: '#9b9b9b',
                            fontWeight: 400,
                            marginBottom: '10px',
                        }}
                    >
                        Environment
                    </Box>
                    <Box
                        sx={{
                            fontSize: '13px',
                            color: 'common.black',
                            fontWeight: 400,
                            marginBottom: '16px',
                        }}
                    >
                        Environment
                    </Box>
                    <Box
                        sx={{
                            fontSize: '12px',
                            color: '#9b9b9b',
                            fontWeight: 400,
                            marginBottom: '10px',
                        }}
                    >
                        Type
                    </Box>
                    <Box
                        sx={{
                            fontSize: '13px',
                            color: 'common.black',
                            fontWeight: 400,
                            marginBottom: '16px',
                        }}
                    >
                        Windows 10 Pro x64
                    </Box>

                    <Button
                        sx={{
                            padding: '7px 15px',
                            border: (theme) =>
                                `solid 1px ${theme.palette.secondary.main}`,
                            fontSize: '14px',
                            color: 'secondary.main',
                            height: '30px',
                            marginBottom: '15px',
                            marginTop: '14px',
                        }}
                    >
                        {btnLabel}
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}

export default ComputerCardView
